import React from "react";
import ClipLoader from "react-spinners/ClipLoader";
const override = {
    align: "center",
  };
export default function Loader(props){
    return(
        <div
          style={{
            visibility:props.loading?"visible":"hidden",
            position: "fixed",
            // top: "0",
            // left: "0",
            width: "100%",
            height: "100%",
            display: "flex",
            zIndex: "200",
            justifyContent: "center",
            alignItems: "center",
            opacity: "0.8"
          }}
        >
          <ClipLoader size={55} cssOverride={override} color="#2185d0" />
         </div>
    )
}

